import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import {
    ScriptLoaderService
} from './../../../../../_services';
import { Unit, Investor, Property, TypeUnit } from './../../../../../_models';
import { Unit as C } from './../../../../../_models/Classes';
import {
    DropImageListModalComponent
} from '../../../../../shared/drop-image-list-modal';
import { UnitFormComponent } from '../unit-form';

const UNIT_INCLUDES = `investor,property,warehouses,parking_spaces,contract,insurance,photos,type_unit`;

@Component({
    templateUrl: '../unit-form/unit-form.component.html',
    styleUrls: ['../unit-form/unit-form.component.scss']

})
export class UnitEditComponent extends UnitFormComponent {
    prevTotalMottoValue: number = 0;
    formHeader = {
        icon: 'fa fa-user',
        text: 'EDITAR UNIDAD'
    }
    @ViewChild(DropImageListModalComponent) imageList: DropImageListModalComponent;
    constructor(private _fbNew: FormBuilder,
        private _scriptNew: ScriptLoaderService,
        private _locationNew: Location,
        private _routeNew: ActivatedRoute,
        private _routerNew: Router,
        private _domSanitizerNew: DomSanitizer,
        private _unitData: Unit,
        private _investorData: Investor,
        private _propertyData: Property,
        private _typeUnitData: TypeUnit
    ) {
        super(_fbNew, _scriptNew, _locationNew, _routeNew, _routerNew, _domSanitizerNew,
            _unitData, _investorData, _propertyData, _typeUnitData);
        this.unitId = this._route.snapshot.params['id'];
        this.form.valueChanges.subscribe(formValue => {
            console.log(formValue);
            if (this.form.valid && this.dataFetched) {
                this.unitData.calculateAgain(formValue, (): number => {
                    return - this.prevTotalMottoValue + this.unitData.item.getMottoValuePool();
                });
                this.requests$ =
                    this.unitData.put(this.unitId, this.getFormData(formValue));
            }
        });
        this.dataFetched = false;
        this.unitData.get(this.unitId, `include=${UNIT_INCLUDES}`)
            .subscribe((unit: C) => {
                this.unit = unit;
                // Unit data
                // Set form value
                this.prevTotalMottoValue = unit.getMottoValuePool();
                this.form.setValue(unit.pick(this.form.value));
                let investor = unit.investor;
                let property = unit.property;
                let typeUnit = unit.type_unit;
                if (investor) {
                    this.form.controls.investor.setValue(investor);
                    if (investor.investor_id)
                        this.form.controls.investor_id.setValue(investor.investor_id);
                }
                if (property) {
                    this.form.controls.property.setValue(property);
                    if (property.property_id)
                        this.form.controls.property_id.setValue(property.property_id);
                }
                this.form.controls.parking_spaces.setValue(unit.parking_spaces.map((space) => {
                    return space.name;
                }));
                this.form.controls.warehouses.setValue(unit.warehouses.map((space) => {
                    return space.name;
                }));
                this._investorData.make(investor);
                this.investorSelect.listing();
                this._propertyData.make(property);
                this.propertySelect.listing();
                this._typeUnitData.make(typeUnit);
                this.typeSelect.listing();
                this.dataFetched = true;
            });
        // Pictures
        this.unitData.getFiles(this.unitId).subscribe(files => {
            this.imageList.files = files;
        });
    }

    end() {
        this._router.navigate([`/units/${this.unitId}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/unit-edit/unit-edit.component.ts